import * as React from "react";

function Preview() {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="30" cy="30" r="30" fill="#0074BD" />
      <path
        d="M46.5938 16.3125L31.5938 10.0625C31.2031 9.90625 30.5781 9.75 30.1875 9.75C29.7188 9.75 29.0938 9.90625 28.7031 10.0625L13.7031 16.3125C12.2969 16.9375 11.4375 18.2656 11.4375 19.75C11.4375 39.9063 26.2031 49.75 30.1094 49.75C34.1719 49.75 48.9375 39.75 48.9375 19.75C48.9375 18.2656 48 16.9375 46.5938 16.3125ZM30.1094 46C22.9219 43.0312 15.1875 33.5 15.1875 19.8281L30.0312 13.5781C30.1094 13.5781 30.1094 13.5781 30.1875 13.5781L45.1875 19.75C45.1875 35.6094 35.3438 43.8906 30.1094 46ZM25.8125 26C25.8125 27.7969 26.8281 29.2812 28.3125 29.9844V35.375C28.3125 36.4688 29.0938 37.25 30.1875 37.25C31.2031 37.25 32.0625 36.4688 32.0625 35.375V29.9844C33.4688 29.2812 34.5625 27.7969 34.5625 26C34.5625 23.6563 32.5313 21.625 30.1875 21.625C27.7656 21.625 25.8125 23.6563 25.8125 26Z"
        fill="white"
      />
    </svg>
  );
}

export default Preview;
